//#region DevExtreme Imports

import 'devextreme/ui/form'

//#endregion

import { USER_SESSION_SERVICE_NAME } from "../../../services/user-session"

import { IMRBaseComponent } from "../base"
import { MAP_SERVICE_NAME } from "../map2"

import { IMRDepositoryParametersController } from "./depository-parameters.controller"

//#region Asset Imports

import './depository-parameters.scss'
import * as TEMPLATE from './depository-parameters.tpl.html'

//#endregion

export const COMPONENT_NAME: string = 'imrDepositoryParameters'

export class IMRDepositoryParametersComponent extends IMRBaseComponent {

    constructor() {
        super({
            controller: IMRDepositoryParametersController,
            services: [MAP_SERVICE_NAME, USER_SESSION_SERVICE_NAME],
            template: TEMPLATE
        })
    }
}